/* eslint-disable radix */
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { FaTimesCircle } from 'react-icons/fa';
import { getArtistMeta, getSpotifySuggestions } from '../../../../api/queries';
import ButtonPrimary from '../../../../components/buttonPrimary';
import LoadingSmall from '../../../../components/loadingSmall';
import SocialSpotify from '../../../../components/socialSpotify';
import Spacer from '../../../../components/spacer';
import AppState from '../../../../store/appstate';
import SuggestionsTable from './SuggestionsTable';

function SongSuggestions({ highlightColour }) {
  const { t } = useTranslation('songs');
  const [spotifyModal, setSpotifyModal] = useState(false);
  const selectedAccount = AppState.useState((s) => s.selectedAccount);
  const artistMeta = getArtistMeta({ aac: selectedAccount });
  useEffect(() => {
    if (selectedAccount) {
      artistMeta.refetch();
    }
  }, [selectedAccount]);

  const spotifyID = artistMeta?.data?.spotify_obj ? JSON.parse(artistMeta?.data?.spotify_obj)?.id : null;

  const suggestions = getSpotifySuggestions({ spotifyid: spotifyID, accountId: selectedAccount });

  // const isrcs = getArtistISRCS({ aac: selectedAccount });

  return (
    <>
      {spotifyModal && (
        <div className="z-40 top-0 left-0 fixed w-screen h-screen flex items-center justify-center bg-black bg-opacity-50">
          <div className="rounded-lg bg-white h-modal relative">
            <button
              type="button"
              onClick={() => setSpotifyModal(false)}
              className="absolute z-50 right-0 top-0 p-5 text-2xl"
            >
              <FaTimesCircle />
            </button>
            <div className="overflow-y-scroll h-modal p-4 lg:p-8">
              <SocialSpotify modal closeModal={() => setSpotifyModal(false)} />
            </div>
          </div>
        </div>
      )}
      <div>
        {artistMeta.isSuccess && !artistMeta?.data?.spotify_obj
        && (
        <div>
          <p>{t('songs:spotify-no-linked-account-text')}</p>
          <Spacer thin />
          <ButtonPrimary id="btnSongSuggestionsLinkSpotify" onClick={() => setSpotifyModal(true)}>
            {t('songs:link-spotify-button')}
          </ButtonPrimary>
        </div>
        )}
        {(spotifyID && suggestions.isLoading)
        && <LoadingSmall />}
        {spotifyID && suggestions?.data
          && (
          <SuggestionsTable
            data={suggestions?.data}
            highlightColour={highlightColour}
          />
          )}
      </div>
    </>
  );
}

export default SongSuggestions;
